import { Box, BoxProps, forwardRef } from '@chakra-ui/react'
import { Helmet } from 'react-helmet-async'
import { Link as RouterLink } from 'react-router-dom'

import { PageHeading, PageHeadingProps } from '../components/page-heading'
import { PageLayout } from '../components/page-layout'
import { ResponsiveContainer } from '../components/responsive-container'
import { SearchResults, SearchResultsSkeleton } from '../components/search-results'
import { TabButton, TabList } from '../components/tab-list'

import { DEFAULT_PAGE_TITLE, useSearchResults } from '../lib'
import { MENUS_ROUTE } from './menus'
import { REGULARS_ROUTE } from './regulars'

export const FAVOURITES_ROUTE = '/favourites'

const FAVOURITE_FILTERS = [
  {
    key: 'is_favourite',
    value: 'true',
  },
]
const FAVOURITE_INITIAL_SORT = ['-favourite_created_at']

const FavouritesPageContent = forwardRef<BoxProps, 'div'>((props, ref) => {
  const { totalCount, isLoadingInitial, ...searchProps } = useSearchResults(
    FAVOURITE_FILTERS,
    FAVOURITE_INITIAL_SORT,
  )

  return (
    <Box ref={ref} {...props}>
      <TabList>
        <TabButton as={RouterLink} to={REGULARS_ROUTE}>
          Regulars
        </TabButton>
        <TabButton as={RouterLink} to={MENUS_ROUTE}>
          Lists
        </TabButton>
        <TabButton as={RouterLink} to={FAVOURITES_ROUTE} isActive={true}>
          Favourites
        </TabButton>
      </TabList>

      {isLoadingInitial && (
        <>
          <SearchResultsSkeleton mt={28} />
        </>
      )}
      {!isLoadingInitial && (
        <>
          {totalCount > 0 && <SearchResults {...searchProps} />}
          {!totalCount && (
            <Box textAlign="center" p={16}>
              You have not yet added any favourites.
            </Box>
          )}
        </>
      )}
    </Box>
  )
})

const FavouritesPageHeader = forwardRef<PageHeadingProps, 'div'>((props, ref) => {
  return (
    <PageHeading ref={ref} {...props} as="div">
      <Box display="flex" justifyContent="space-between">
        <Box as="h1" mr={4}>
          Favourites
        </Box>
      </Box>
    </PageHeading>
  )
})

export const FavouritesPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>{DEFAULT_PAGE_TITLE}</title>
      </Helmet>
      <PageLayout>
        <ResponsiveContainer>
          <FavouritesPageHeader />
          <FavouritesPageContent />
        </ResponsiveContainer>
      </PageLayout>
    </>
  )
}
